import Highcharts from 'highcharts';
import './legendExpander';
import './legendSorter';
import {tooltipFormatter} from './tooltipFormatter';
import {format} from '../../filters/format';

/**
 * Highchart charts theme.
 */

export default Highcharts.theme = {
  colors: ['#4ea2d1', '#aaaaaa', '#f09877', '#4fcfa1', '#24CBE5', '#64E572',
    '#FF9655', '#FFF263', '#6AF9C4'],
  chart: {
    backgroundColor: '',
    spacingTop: 12,
    spacingBottom: 12,
    spacingLeft: 20,
    spacingRight: 20,
    alignTicks: false,
    style: {
      font: '12px "proxima-nova", sans-serif'
    },
  },
  title: {
    useHTML: true,
    text: ''
  },
  subtitle: {
    style: {
      color: '#444',
      font: '600 12px "proxima-nova", sans-serif'
    },
  },
  legend: {
    itemStyle: {
      font: '12px "proxima-nova", sans-serif',
      color: 'black',
      opacity: '1'
    },
    margin: 30,
    enabled: true,
    align: 'left',
    verticalAlign: 'top',
    useHTML: true,
    labelFormatter: function () {
      let label = '';
      let markup = '<span class="c-chart-legend__item';

      if (!this.visible) {
        markup += ' is-faded';
      }

      if (this.options.bigLabel) {
        markup += ' c-chart-legend__item--big"' +  // add big class to item
          'style="color:' + this.color + '">' + // add styling
          format(this.options.bigLabel.value, this.options.format);
        if (this.options.bigLabel.label) {
          label = this.options.bigLabel.label;
        } else {
          label = this.name;
        }
      } else {
        markup += '">' +
          '<span class="c-chart-legend__item-marker" style="-webkit-print-color-adjust: exact;color:' +
          this.color + '">' +
          '</span>';
        label = this.name;
      }

      markup += '<span class="c-chart-legend__item-label">' +
          _.truncate(label, {length: 60, separator: /,? +/, omission: '...'}) + '</span>';

      return markup;
    }
  },
  plotOptions: {
    series: {
      events: {
        hide: function () {
          $(this.legendGroup.div).find('.c-chart-legend__item')
            .addClass('is-faded');
        },
        show: function () {
          $(this.legendGroup.div).find('.c-chart-legend__item')
            .removeClass('is-faded');
        }
      },
      states: {
        hover: {}
      },
      lineWidth: 3,
      lineWidthPlus: 0,
      cursor: 'pointer',
      animation: {
        duration: 2000,
        easing: 'swing'
      }
    },
    column: {
      maxPointWidth: 10,
    },
    spline: {
      lineWidthPlus: 0,
      states: {
        hover: {
          lineWidth: 3
        }
      },
      marker: {
        radius: 0,
        states: {
          hover: {
            enabled: true,
            fillColor: '#595d6e',
            lineWidth: 2,
            radius: 7,
          }
        }
      }
    },
    pie: {
      borderColor: null,
      lineWidthPlus: 0,
      states: {
        hover: {
          brightness: 0,
          lineWidth: 0,
          lineWidthPlus: 0,
          halo: {
            size: 10,
            opacity: 1
          }
        }
      }
    },
    bar: {
      stacking: 'normal',
      customBorderRadius: 5,
      lineWidthPlus: 0,
      states: {
        hover: {
          lineWidth: 4
        }
      },
      marker: {
        lineWidth: 2,
        radius: 7,
        states: {
          hover: {
            enabled: true,
            fillColor: '#595d6e',
            lineWidth: 2,
            radius: 7,
          }
        }
      }
    },
    area: {
      lineWidthPlus: 0,
      states: {
        hover: {
          lineWidth: 3
        }
      },
      marker: {
        radius: 0,
        states: {
          hover: {
            enabled: true,
            fillColor: '#595d6e',
            lineWidth: 2,
            radius: 7,
          }
        }
      }
    },
    solidgauge: {
      align: 'center',
      innerRadius: '99%',
      dataLabels: {
        y: -30,
        borderWidth: 0,
        useHTML: true,
        format: '<div class="c-chart-legend__item-label">' +
        '{y}k<br/>' +
        '<b>{series.name}</b></div>'
      }
    }
  },
  tooltip: {
    style: {
      font: '700 12px "proxima-nova", sans-serif'
    },
    positioner: function (labelWidth, labelHeight, point) {
      let tooltipX;
      let tooltipY;
      if (point.plotX + labelWidth > this.chart.plotWidth) {
        tooltipX = point.plotX + this.chart.plotLeft - labelWidth - 20;
      } else {
        tooltipX = point.plotX + this.chart.plotLeft + 20;
      }
      tooltipY = point.plotY + this.chart.plotTop - 20;

      return {
        x: tooltipX,
        y: tooltipY
      };
    },
    formatter: tooltipFormatter,
    backgroundColor: '#fff',
    borderColor: '#e1e1e1',
    useHTML: true
  },
  credits: {
    enabled: false
  }
};

// Apply the theme
Highcharts.setOptions(Highcharts.theme);

// Gradientize the colors
Highcharts.getOptions().colorsGradient = Highcharts
  .map(Highcharts.getOptions().colors, function (color) {

    return {
      linearGradient: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 1
      },
      stops: [
        [0, color],
        [1, Highcharts.Color(color).brighten(0.8)
          .setOpacity(0).get('rgba')]
      ]
    };
  });

/* Round corners column and bar generators */
function getColumnShapeArgs(params) {
  var x = params.x;
  var y = params.y;
  var h = params.height;
  var w = params.width;
  var br = params.br || w / 2;
  var shapeArgs = {};

  if (params.stackingFirst) {
    shapeArgs = {
      d: [
        'M', x, y,
        'v', h - br,
        'a', br, br, 0, 0, 0, br, br,
        'h', w - 2 * br,
        'a', br, br, 0, 0, 0, br, -br,
        'v', -h, 'h', -w
      ]
    };
  } else if (params.negative) {
    shapeArgs = {
      d: [
        'M', x, y,
        'v', h - br,
        'a', br, br, 0, 0, 0, br, br,
        'h', w - 2 * br,
        'a', br, br, 0, 0, 0, br, -br,
        'v', -h, 'h', -w
      ]
    };
  } else {
    shapeArgs = {
      d: [
        'M', x, y + br,
        'v', h,
        'h', w,
        'v', -h,
        'a', br, br, 0, 0, 0, -br, -br,
        'h', -w + 2 * br,
        'a', br, br, 0, 0, 0, -br, br
      ]
    };
  }

  return shapeArgs;
}

/* Make all column and bar charts with round corners */
Highcharts.wrap(Highcharts.seriesTypes.column.prototype, 'translate',
  function(proceed) {

    proceed.apply(this, [].slice.call(arguments, 1));
    var self = this;
    var shapeArgs;

    Highcharts.each(self.points, function(point) {
      if (self.userOptions.dontRoundBorders || self.options.dontRoundBorders) {
        return; // Disable round corners if explicitly set.
      }
      shapeArgs = $.extend({}, point.shapeArgs);
      shapeArgs.br = self.options.customBorderRadius;
      shapeArgs.negative = point.negative;

      point.shapeType = 'path';
      point.shapeArgs = getColumnShapeArgs(shapeArgs);
    });
  }); // end Highcharts.wrap



/** WEBPACK FOOTER **
 ** ./src/common/analyticsPanel/charts-theme.js
 **/